import * as React from 'react';
import { Query } from 'react-apollo';
import { CURRENT_USER } from '@graphql/queries/user';
import { CurrentUser } from '@graphql/types';

import { Router } from './Routes';
import { Spinner } from '@components/Spinner';
import { JoyHeader } from '@components/JoyHeader';
import { ErrorPage } from '@components/Error';

export const RouterContext: React.SFC<{}> = () => {
  return (
    <Query<CurrentUser> query={CURRENT_USER} notifyOnNetworkStatusChange={true} fetchPolicy={'network-only'}>
      {({ loading, error, data, refetch }) => {
        if (loading) {
          return (
            <div style={{ margin: '40px' }}>
              <JoyHeader />
              <Spinner style={{ top: '20%', height: '50%' }} id={'CURRENT_USER'} />
            </div>
          );
        }
        if (error) {
          // this is here for the case when preview loads but the iframe errors out
          // we want the error component to render in the preview route not inside the iframe
          try {
            if (window.top.onIframeError) {
              window.top.onIframeError(error);
              return;
            }
          } catch (e) {
            // do nothing
          }
          return (
            <ErrorPage
              page="RouterContext"
              pagePrefix="marketing"
              category="Bliss"
              attemptedAction="Current User Query"
              error={error}
            />
          );
        }
        if (data) {
          return <Router refetch={refetch} currentUserContext={data} />;
        }
        return <div>Oh no!</div>;
      }}
    </Query>
  );
};
